import { POST } from "./api";

export const validateLink = async (params) => {
  return await POST(`/validate-link`, params);
};
